import { ReactNode } from 'react';
import { EntityRatingCommentCount, Laboratory, Rating } from '@medprev-web-app/api-graphql-client';

import { EntityActionHeader } from '@/app/(main)/(pages)/_components/entities/entity-action-header.component';
import { EntityRating } from '@/app/(main)/(pages)/_components/entities/entity-rating-sumary.component';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import PartnerShowAddress from '@/app/(main)/(pages)/(institucional)/(index)/parceiros/_components/partner-show-address.component';
import { resolveLaboratoryName } from '@/utils/laboratory/laboratory.util';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface PartnerHeaderProps {
  laboratory: Laboratory;
  commentsCount?: EntityRatingCommentCount | null;
  coverageBanner?: ReactNode;
  onSelectExams?: () => void;
}

export function BranchLaboratoryHeader({
  laboratory,
  commentsCount,
  coverageBanner,
  onSelectExams,
}: PartnerHeaderProps) {
  const formatAddress = (): string | undefined => {
    const { neighborhood, city, state } = laboratory;

    return `${neighborhood} • ${city} - ${state}`;
  };

  const laboratoryName = resolveLaboratoryName(laboratory);

  return (
    <>
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
        <EntityAvatar
          src={laboratory.main.avatar}
          size="xxxl"
          alt={`Foto de perfil de ${laboratoryName}`}
          type={EntityTypeEnum.LABORATORY_COLLECT_POINT}
          shouldAddLightbox
          priority
          data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_AVATAR}
        />

        <div>
          <div className="max-w-xs sm:max-w-[400px] m-auto md:m-0">
            <Typography
              variant={TypographyVariant.MODAL_TITLE}
              className="text-center md:text-left break-words text-wrap hyphens-auto overflow-hidden"
            >
              {laboratoryName}
            </Typography>
          </div>

          <ol className="flex flex-col items-center md:items-start mt-2">
            <li className="text-gray-700 text-sm flex flex-col items-center md:items-start justify-center">
              <span className="flex items-center gap-1">{formatAddress()}</span>
              <PartnerShowAddress
                data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_VIEW_ADDRESS}
              />
            </li>
          </ol>
        </div>
      </div>
      <div className="mt-5">
        <EntityRating
          rating={laboratory.rating as Rating}
          commentsCount={commentsCount}
          data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_REVIEWS_AND_COMMENTS}
        />
      </div>

      {coverageBanner && <div className="mt-5 md:mt-3">{coverageBanner}</div>}

      <div className={coverageBanner ? 'mt-3' : 'mt-5 md:mt-3'}>
        <EntityActionHeader
          entityType={EntityTypeEnum.LABORATORY_COLLECT_POINT}
          entity={laboratory}
          onSelectExams={onSelectExams}
        />
      </div>
    </>
  );
}
